"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var actionTypes_1 = require('./actionTypes');
var store_1 = require('@ngrx/store');
var core_1 = require('angular2/core');
var NotificationActions = (function () {
    function NotificationActions(store) {
        this.store = store;
    }
    NotificationActions.prototype.addAlert = function (message) {
        this.store.dispatch({ type: actionTypes_1.ADD_ALERT_NOTIFICATION, payload: message });
    };
    NotificationActions.prototype.addError = function (message) {
        this.store.dispatch({ type: actionTypes_1.ADD_ERROR_NOTIFICATION, payload: message });
    };
    NotificationActions.prototype.clearNotification = function (id) {
        this.store.dispatch({ type: actionTypes_1.CLEAR_NOTIFICATION, payload: id });
    };
    NotificationActions = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [store_1.Store])
    ], NotificationActions);
    return NotificationActions;
}());
exports.NotificationActions = NotificationActions;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/actions/actions.ts
 ** module id = 245
 ** module chunks = 0
 **/